import { jsx, jsxs } from "react/jsx-runtime";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  MessageBar,
  MessageBarActions,
  MessageBarBody,
  MessageBarTitle
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
function UpgradePrompt(props) {
  const { t } = useTranslation("ui");
  const message = props.message ?? t("components.upgradePrompt.message");
  const title = props.title ?? t("components.upgradePrompt.title");
  const action = t("components.upgradePrompt.action");
  const dismiss = t("components.upgradePrompt.dismiss");
  if (props.variant === "dialog") {
    const { open, onOpenChange, onUpgrade: onUpgrade2 } = props;
    return /* @__PURE__ */ jsx(
      Dialog,
      {
        open,
        modalType: "modal",
        onOpenChange: (_event, data) => {
          onOpenChange(data.open);
        },
        children: /* @__PURE__ */ jsx(DialogSurface, { children: /* @__PURE__ */ jsxs(DialogBody, { children: [
          /* @__PURE__ */ jsx(DialogTitle, { children: title }),
          /* @__PURE__ */ jsx(DialogContent, { children: message }),
          /* @__PURE__ */ jsxs(DialogActions, { children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                appearance: "secondary",
                onClick: () => {
                  onOpenChange(false);
                },
                children: dismiss
              }
            ),
            onUpgrade2 ? /* @__PURE__ */ jsx(Button, { appearance: "primary", onClick: onUpgrade2, children: action }) : null
          ] })
        ] }) })
      }
    );
  }
  const { onUpgrade, onDismiss } = props;
  return /* @__PURE__ */ jsxs(MessageBar, { intent: "warning", layout: "auto", children: [
    /* @__PURE__ */ jsxs(MessageBarBody, { children: [
      /* @__PURE__ */ jsx(MessageBarTitle, { children: title }),
      message
    ] }),
    /* @__PURE__ */ jsxs(MessageBarActions, { children: [
      onUpgrade ? /* @__PURE__ */ jsx(Button, { appearance: "primary", size: "small", onClick: onUpgrade, children: action }) : null,
      onDismiss ? /* @__PURE__ */ jsx(Button, { appearance: "secondary", size: "small", onClick: onDismiss, children: dismiss }) : null
    ] })
  ] });
}
export {
  UpgradePrompt
};
//# sourceMappingURL=upgrade-prompt.js.map